// src/cert/iso50001.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const ISO50001 = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>ISO 50001 प्रमाणन</h1>
                <p>ऊर्जा व्यवस्थापन प्रणाली (Energy Management System)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>..ISO 50001..</h2>
                    <p>

                        Certification to the ISO 50001 standard ensures that your organization has a healthy energy management system, reducing energy consumption, environmental impact and increasing profitability.

                        It specifies requirements for management practices that are important to obtain improved energy performance. Demonstrates to customers, employees, and stakeholders that efficient use of energy is prioritised in your organisation and that energy is managed systematically. Allows for credible market communication about energy performance efforts.

                        SO 50001 is a voluntary international standard. It applies to organisations of any size, and provides requirements for establishing, managing and improving their energy consumption and efficiency.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>ऊर्जा खर्चात 10-30% बचत</li>
                        <li>कार्बन फूटप्रिंट आणि प्रदूषण कमी</li>
                        <li>कायदेशीर आणि पर्यावरणीय अनुपालन</li>
                        <li>संस्थेची प्रतिष्ठा आणि ESG स्कोअर वाढतो</li>
                        <li>ऊर्जा डेटा ट्रॅकिंग आणि सुधारणा योजना</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>ISO 50001 साठी अर्ज करा</h2>
                    <ApplyForm certification="ISO 50001" />
                </section>
            </div>
        </div>
    );
};

export default ISO50001;